<template>
<div>
  <navigation></navigation>
  <!--Main contents-->
  <div class="box_center" id="page_x">
    <h2 class="shadow">Change Password</h2>
    <div id="feedback" v-if="errors.any() || error">
      <p class="error wrong_name error-box" v-if="errors.has('oldPassword')">Please enter your current password</p>
      <p class="error wrong_email error-box" v-if="errors.has('newPassword')">Please enter your new password</p>
      <p class="error wrong_message error-box" v-if="errors.has('confirmPassword')">Please repeat password</p>
      <p class="error wrong_message error-box" v-if="error">{{error}}</p>
    </div>
    <div class="input">
      <form @submit.prevent="save" name="change">
        <p class="text_form">
          Current: <br />
          New: <br />
          Confirm:
        </p>
        <input type="password" name="oldPassword" maxlength="30" v-model="oldPassword" v-validate="'min:8|required'" class="contact_form" data-vv-delay="2000"/>
        <input type="password" name="newPassword" maxlength="30" v-model="newPassword" v-validate="'min:8|required|confirmed:confirmPassword'" class="contact_form" data-vv-delay="1000"/>
        <input type="password" id="label_name" name="confirmPassword" maxlength="30" v-model="confirmPassword" v-validate="'required'" data-vv-delay="1000" class="contact_form"/>
        <input type="submit" value="Submit" name="submitButton" title="Submit" class="button submit">
      </form>
    </div>
  </div>
</div>
<!--Main contents Ends-->
</template>

<script>
import Nav from '../components/Nav'
import AuthRepository from '../data/auth.repository'
export default {
  components: {
    'navigation': Nav
  },
  data () {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      error: ''
    }
  },
  methods: {
    save () {
      const obj = {oldPassword: this.oldPassword, newPassword: this.newPassword, confirmPassword: this.confirmPassword, id: this.user.id}
      AuthRepository.changePassword(obj).then((result) => {
        this.$router.push('/myaccount')
      }).catch((e) => {
        if (e.response && e.response.data && e.response.data.error) {
          this.error = e.response.data.error
        }
      })
    }
  },
  computed: {
    user () {
      return this.$store.state.currentUser
    }
  },
  metaInfo: {
    title: 'Change Password'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// ChangePassword.vue?20b29f89